module.exports = "/_next/static/images/anonymous-9bc1f2f8c428cc49c1d06e9f02f23ed5.png";